// extracted by mini-css-extract-plugin
module.exports = {"container":"SuggestionCard_container__fWHZL","image":"SuggestionCard_image__NUDGV","link":"SuggestionCard_link__9v2qG","label":"SuggestionCard_label__EBhQL"};